/**
 * Extracts and formats the weekly opening hours from the store's place details.
 * It parses the weekday text provided by the API, handles cases like "Closed" or missing data,
 * normalizes special characters and time ranges, and converts times from 12-hour to 24-hour format.
 * The result is an array of objects with each day and its corresponding open-close timing.
 */
const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const getWeekwiseTimingsFromWeekdayText = (storeTimings: any[]) => {
  if (!Array.isArray(storeTimings) || storeTimings.length === 0) {
    // Return fallback with "Not available"
    return daysOfWeek?.map((day) => ({
      day,
      time: { openTime: 'Not available', closeTime: 'Not available' },
    }));
  }

  // Normalize input (ensure we have lowercase days)
  const normalized = storeTimings.map((t) => ({
    ...t,
    day: t.day.toLowerCase(),
  }));

  // Create consistent output sorted by week order
  return daysOfWeek.map((day) => {
    const dayKey = day.toLowerCase();
    const entry = normalized.find((t) => t.day === dayKey);

    if (!entry) {
      return {
        day,
        time: { openTime: 'Not available', closeTime: 'Not available' },
      };
    }

    if (!entry.isOpen) {
      return { day, time: { openTime: 'Closed', closeTime: '' } };
    }

    return {
      day,
      time: { openTime: entry.openTime, closeTime: entry.closeTime },
    };
  });
};

// export const getWeekwiseTimingsFromWeekdayText = (store: any) => {
//   const opening = store.placeDetails?.opening_hours;
//   if (!opening || !opening.weekday_text) {
//     return daysOfWeek.map((day) => ({ day, time: 'Not available' }));
//   }

//   return opening.weekday_text.map((text: any) => {
//     // Split on the first colon only
//     const splitIndex = text.indexOf(':');
//     const day = text.substring(0, splitIndex).trim();
//     const timePart = text.substring(splitIndex + 1).trim();

//     if (!timePart || timePart.toLowerCase() === 'closed') {
//       return { day, time: 'Closed' };
//     }

//     // Normalize spaces and dashes
//     const normalized = timePart
//       .replace(/\u202f|\u2009|\u00a0/g, ' ') // replace special spaces with normal space
//       .replace(/–|—|-/g, '–'); // unify dash types

//     const times = normalized.split('–').map((t: any) => t.trim());

//     if (times.length !== 2) {
//       return { day, time: normalized };
//     }

//     const convertTo24Hour = (timeStr: string) => {
//       const parts = timeStr.split(' ').map((s) => s.trim());
//       if (parts.length !== 2) return timeStr; // fallback

//       let [time, modifier] = parts;
//       let [hours, minutes] = time.split(':').map(Number);

//       if (modifier.toUpperCase() === 'PM' && hours !== 12) {
//         hours += 12;
//       }
//       if (modifier.toUpperCase() === 'AM' && hours === 12) {
//         hours = 0;
//       }
//       const hh = hours.toString().padStart(2, '0');
//       const mm = minutes.toString().padStart(2, '0');
//       return `${hh}:${mm}`;
//     };

//     const openTime = convertTo24Hour(times[0]);
//     const closeTime = convertTo24Hour(times[1]);

//     return { day, time: { openTime, closeTime } };
//   });
// };
